import { Select } from '@mantine/core';
import { CommonInputProps } from './DataInputField';

type DataInputSelectProps = CommonInputProps & {
  options: { value: string; label: string }[];
};

export function DataInputSelect({
  inputValue,
  setInputValue,
  onSave,
  onKeyDown,
  variant,
  autoFocus,
  options,
  ariaLabelledBy,
}: DataInputSelectProps) {
  return (
    <Select
      value={String(inputValue || '')}
      onChange={val => setInputValue(val || '')}
      onKeyDown={onKeyDown}
      onBlur={onSave}
      data={options}
      searchable={options.length > 5}
      clearable
      variant={variant}
      autoFocus={autoFocus}
      miw={120}
      aria-labelledby={ariaLabelledBy}
    />
  );
}
